import React from 'react';
import classnames from 'classnames';
import {bool, func} from 'prop-types';
import {Checkbox, Grid} from 'semantic-ui-react';
import FieldStatusIcon from 'components/forms/FieldStatusIcon';
import {EmptyFunc} from 'utils/DBUtils';

export default class AutoSaveFeaturedCheckbox extends React.Component {
  static propTypes = {
    checked: bool,
    onChange: func,
    isSaving: bool,
    saveError: bool,
    saveSuccess: bool
  };

  static defaultProps = {
    onChange: EmptyFunc
  };

  handleChange = event => {
    this.props.onChange(!this.props.checked);
  };

  get className() {
    return classnames('auto-save-featured-checkbox', {error: this.props.saveError});
  }

  render() {
    return (
      <div className={this.className}>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column verticalAlign='top'>
              <Checkbox
                checked={this.props.checked}
                onChange={this.handleChange} />
            </Grid.Column>
            <Grid.Column verticalAlign='top'>
              <FieldStatusIcon
                error={this.props.saveError}
                isSaving={this.props.isSaving}
                saved={this.props.saveSuccess} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./public/pages/ListWinners/AutoSaveFeaturedCheckbox.jsx